(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ridek-catalog"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ridek-favorites')) {
  customElements.define('ridek-favorites', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.ridek-new-products');
      if (!this.track) return;
      this.abort = new AbortController();
      const signal = this.abort.signal;
      const behavior = () => matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth';
      this.track.addEventListener('keydown', event => {
        if (this.track.scrollWidth <= this.track.clientWidth || event.target !== this.track || event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) return;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const step = this.track.firstElementChild?.getBoundingClientRect().width + gap;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          this.track.scrollBy({left: (event.key === 'ArrowRight' ? 1 : -1) * step, behavior: behavior()});
        } else if (event.key === 'Home' || event.key === 'End') {
          event.preventDefault();
          this.track.scrollTo({left: event.key === 'Home' ? 0 : this.track.scrollWidth, behavior: behavior()});
        }
      }, {signal});
      this.track.addEventListener('dragstart', event => event.preventDefault(), {signal});
      this.track.addEventListener('pointerdown', event => {
        if (this.track.scrollWidth <= this.track.clientWidth || event.pointerType !== 'mouse' || event.button !== 0) return;
        this.drag = {id: event.pointerId, x: event.clientX, y: event.clientY, left: this.track.scrollLeft, moved: false};
      }, {signal});
      this.track.addEventListener('pointermove', event => {
        const drag = this.drag;
        if (!drag || event.pointerId !== drag.id) return;
        if (!(event.buttons & 1)) {
          this.track.classList.remove('is-dragging');
          this.drag = null;
          return;
        }
        const distance = event.clientX - drag.x;
        if (!drag.moved && Math.abs(distance) > 6 && Math.abs(distance) > Math.abs(event.clientY - drag.y)) {
          drag.moved = true;
          this.track.setPointerCapture(event.pointerId);
          this.track.classList.add('is-dragging');
        }
        if (drag.moved) {
          event.preventDefault();
          this.track.scrollLeft = drag.left - distance;
        }
      }, {signal});
      const finish = event => {
        if (!this.drag || event.pointerId !== this.drag.id) return;
        if (this.drag.moved) this.ignoreClickUntil = performance.now() + 300;
        if (this.track.hasPointerCapture(event.pointerId)) this.track.releasePointerCapture(event.pointerId);
        this.track.classList.remove('is-dragging');
        this.drag = null;
      };
      this.track.addEventListener('pointerup', finish, {signal});
      this.track.addEventListener('pointercancel', finish, {signal});
      this.track.addEventListener('lostpointercapture', finish, {signal});
      this.track.addEventListener('click', event => {
        if (event.detail > 0 && performance.now() < (this.ignoreClickUntil || 0)) {
          event.preventDefault();
          event.stopPropagation();
        }
      }, {capture: true, signal});
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.track?.classList.remove('is-dragging');
      this.drag = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
